<script setup lang="ts">
import { assert } from '~~/src/layers/toolkit/toolkit';
import { items } from '..';
import type { NavbarDropdownType } from '../dropdown';

const props = defineProps<{ dropdownType?: NavbarDropdownType | null }>();
const emit = defineEmits<{
  dropdownOpen: [value: NavbarDropdownType];
  dropdownClose: [];
}>();

function openDropdown(type: NavbarDropdownType | undefined) {
  assert(
    type !== undefined,
    'Only links with defined dropdown are able to open it',
  );
  emit('dropdownOpen', type);
}
function isDropdownTypeActive(type: NavbarDropdownType | undefined) {
  return props.dropdownType !== undefined && type === props.dropdownType;
}
</script>

<template>
  <ul class="gap-r8 flex items-center">
    <NavbarLink
      v-for="item in items"
      :key="item.label"
      :item
      :dropdown-open="isDropdownTypeActive(item.dropdown?.type)"
      @dropdown-open="openDropdown(item.dropdown?.type)"
      @dropdown-close="$emit('dropdownClose')"
    />
  </ul>
</template>
